import React from 'react';
import { Input } from '../../../../Forms';
export var StringField = function StringField(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onChange = _ref.onChange,
    size = _ref.size,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'left' : _ref$textAlign;
  return React.createElement("div", null, React.createElement(Input, {
    textAlign: textAlign,
    name: "field-".concat(field.field),
    value: value,
    onChange: onChange,
    bordered: true,
    size: size
  }));
};